<template>
    <table class="orders-table" :class="{'compact-table': compact}">
        <thead>
            <tr>
                <th>
                    {{tokens.ordersPane.symbol}}
                </th>
                <th class="no-mobile" :class="{'compact-hide': compact}">
                    {{tokens.ordersPane.id}}
                </th>
                <th :class="{'compact-hide': compact}">
                    {{tokens.ordersPane.type}}
                </th>
                <th :class="{'compact-hide': compact}">
                    {{tokens.ordersPane.volume}}
                </th>
                <th class="no-mobile">
                    {{tokens.ordersPane.openPrice}}
                </th>
                <th class="no-mobile" :class="{'compact-hide': compact}">
                    {{tokens.ordersPane.openTime}}
                </th>
                <th class="no-mobile" :class="{'compact-hide': compact}">
                    {{tokens.ordersPane.sl}}
                </th>
                <th class="no-mobile" :class="{'compact-hide': compact}">
                    {{tokens.ordersPane.tp}}
                </th>
                <th>
                    {{tokens.ordersPane.price}}
                </th>
                <th class="no-mobile" :class="{'compact-hide': compact}">
                    {{tokens.ordersPane.commission}}
                </th>
                <th class="no-mobile" :class="{'compact-hide': compact}">
                    {{tokens.ordersPane.swap}}
                </th>
                <th>
                    {{tokens.ordersPane.pnl}}
                </th>
                <th :class="{'compact-hide': compact}">
                    {{tokens.ordersPane.actions}}
                </th>

            </tr>
        </thead>
        <tbody>
            <template v-for="order in orders">
            <tr :key="order.id"
                v-on:click="rowClick(order)"
                :class="{'compact-row': compact, 'is-expanded': compact && !!expanded[order.id]}"
            >
                <td>
                    <span class="symbol" :class="'symbol-'+order.symbol.toUpperCase()" />
                    {{symbols[order.symbol] ? symbols[order.symbol].alias : ''}}
                </td>
                <td class="no-mobile" :class="{'compact-hide': compact}">
                    {{order.id}}
                </td>
                <td :class="[order.type % 2 ? 'red' : 'green', {'compact-hide': compact}]">
                    {{orderTypeString(order.type)}}
                </td>
                <td :class="{'compact-hide': compact}">
                    {{order.volume.toLocaleString()}}
                </td>
                <td  class="no-mobile">
                   {{symbols[order.symbol] ? order.price_open.toLocaleString(undefined, { minimumFractionDigits: symbols[order.symbol] ? symbols[order.symbol].precision : 3, maximumFractionDigits:  symbols[order.symbol] ? symbols[order.symbol].precision : 3 }) : 0}}
                </td>
                <td class="no-mobile" :class="{'compact-hide': compact}">
                    {{new Date(order.time_open * 1000).toLocaleString()}}
                </td>
                <td class="no-mobile" :class="{'compact-hide': compact}">
                    {{order.sl && symbols[order.symbol] ? order.sl.toLocaleString(undefined, { minimumFractionDigits: symbols[order.symbol] ? symbols[order.symbol].precision : 3, maximumFractionDigits:  symbols[order.symbol] ? symbols[order.symbol].precision : 3 }) : '-'}}
                </td>
                <td class="no-mobile" :class="{'compact-hide': compact}">
                    {{order.tp && symbols[order.symbol] ? order.tp.toLocaleString(undefined, { minimumFractionDigits: symbols[order.symbol] ? symbols[order.symbol].precision : 3, maximumFractionDigits:  symbols[order.symbol] ? symbols[order.symbol].precision : 3 }) : '-'}}
                </td>
                <td :class="!symbols[order.symbol] ? '' : ([0, 3, 5].indexOf(order.type) === -1 ? symbols[order.symbol].quote.dirAsk : symbols[order.symbol].quote.dirBid)">
                    {{symbols[order.symbol] ? (symbols[order.symbol].quote[[0, 3, 5].indexOf(order.type) === -1 ? 'ask' : 'bid'] || 0).toLocaleString(undefined, { minimumFractionDigits: symbols[order.symbol] ? symbols[order.symbol].precision : 3, maximumFractionDigits:  symbols[order.symbol] ? symbols[order.symbol].precision : 3 }) : ''}}
                </td>
                <td class="no-mobile" :class="{'compact-hide': compact}">
                    {{ currencySign(activeAccount.currency) + order.commission.toLocaleString(undefined, { minimumFractionDigits: activeAccount.precision, maximumFractionDigits: activeAccount.precision }) }}
                </td>
                <td class="no-mobile" :class="{'compact-hide': compact}">
                    {{ (order && order.swap !== null && order.swap !== undefined && activeAccount && activeAccount.currency && activeAccount.precision !== null && activeAccount.precision !== undefined) ?
                    (currencySign(activeAccount.currency) + order.swap.toLocaleString(undefined, { minimumFractionDigits: activeAccount.precision, maximumFractionDigits: activeAccount.precision })) : '-' }}
                </td>
                <td :class="getOrderStyle(order)" >
                    {{getOrderPnl(order)}}
                </td>
                <td :class="{'compact-hide': compact}">
                    <span v-on:click.stop="showAutoCloseModal($event, order.id)">{{ tokens.ordersPane.edit}}</span>
                    <span v-on:click.stop="showCloseOrderConfirmation(order.id)">{{ tokens.ordersPane.close}}</span>
                </td>
            </tr>
            <tr v-if="compact && expanded[order.id]" :key="order.id + '-detail'" class="order-detail">
                <td colspan="4">
                    <div class="detail-grid">
                        <span class="k">{{tokens.ordersPane.id}}</span><span class="v">{{order.id}}</span>
                        <span class="k">{{tokens.ordersPane.type}}</span><span class="v" :class="order.type % 2 ? 'red' : 'green'">{{orderTypeString(order.type)}}</span>
                        <span class="k">{{tokens.ordersPane.volume}}</span><span class="v">{{order.volume.toLocaleString()}}</span>
                        <span class="k">{{tokens.ordersPane.openTime}}</span><span class="v">{{new Date(order.time_open * 1000).toLocaleString()}}</span>
                        <span class="k">{{tokens.ordersPane.sl}}</span><span class="v">{{priceValue(order, order.sl)}}</span>
                        <span class="k">{{tokens.ordersPane.tp}}</span><span class="v">{{priceValue(order, order.tp)}}</span>
                        <span class="k">{{tokens.ordersPane.commission}}</span><span class="v">{{accountValue(order.commission)}}</span>
                        <span class="k">{{tokens.ordersPane.swap}}</span><span class="v">{{accountValue(order.swap)}}</span>
                    </div>
                    <div class="detail-actions">
                        <span v-on:click.stop="showAutoCloseModal($event, order.id)">{{ tokens.ordersPane.edit}}</span>
                        <span v-on:click.stop="showCloseOrderConfirmation(order.id)">{{ tokens.ordersPane.close}}</span>
                    </div>
                </td>
            </tr>
            </template>
        </tbody>
    </table>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {orderTypeString, timeToString, currencySign} from "@/common/helpers";
    import {
        MODAL,
        MODAL_CLOSE_POSITION,
        MODAL_AUTOCLOSE,
        SYMBOL_ACTIVE_UPDATE,
        NOTIFICATION_ERROR
    } from '@/store/mutations.type'
    import {STATIC_BASE, MOBILE_COMPACT_ORDERS} from "@/common/config"
    import {isMobile} from "@/common/helpers"

    export default {
        name: "OrdersTable",
        data() {
            return {
                staticBase: STATIC_BASE,
                // Collapsed rows carry Symbol, Open Price, Price and P&L only; tapping a row
                // reveals the rest. Opt-in per brand and mobile only, so desktop is untouched.
                compact: !!MOBILE_COMPACT_ORDERS && isMobile(),
                expanded: {}
            }
        },
        computed: {
            ...mapGetters(['tokens', 'orders', 'symbols', 'activeAccount', 'user', 'chartActive'])
        },
        methods: {
            orderTypeString,
            timeToString,
            currencySign,
            getOrderStyle(order) {
                const symbol = this.symbols[order.symbol]
                if (!symbol) {
                    return ''
                }
                const diff = order.type ? order.price_open - symbol.quote.ask : symbol.quote.bid - order.price_open
                const value = order.point * diff * Math.pow(10, symbol.precision) + order.swap + order.commission
                return value >= 0 ? 'green' : 'red'
            },
            getOrderPnl(order) {
                const symbol = this.symbols[order.symbol]
                if (order.type >= 2) {
                    return '0'
                }
                if (!symbol) {
                    return '-'
                }
                const diff = order.type ? order.price_open - symbol.quote.ask : symbol.quote.bid - order.price_open
                const value = order.point * diff * Math.pow(10, symbol.precision) + order.swap + order.commission
                const formattedValue = value.toLocaleString(undefined, {
                    minimumFractionDigits: this.activeAccount.precision,
                    maximumFractionDigits: this.activeAccount.precision,
                })
                return `${currencySign(this.activeAccount.currency)}${formattedValue}`
            },
            rowClick(order) {
                this.setActiveSymbol(order.symbol)
                if (!this.compact) {
                    return
                }
                this.$set(this.expanded, order.id, !this.expanded[order.id])
            },
            priceValue(order, value) {
                const symbol = this.symbols[order.symbol]
                if (!value || !symbol) {
                    return '-'
                }
                return value.toLocaleString(undefined, {
                    minimumFractionDigits: symbol.precision,
                    maximumFractionDigits: symbol.precision
                })
            },
            accountValue(value) {
                if (value === null || value === undefined || !this.activeAccount || !this.activeAccount.currency) {
                    return '-'
                }
                return currencySign(this.activeAccount.currency) + value.toLocaleString(undefined, {
                    minimumFractionDigits: this.activeAccount.precision,
                    maximumFractionDigits: this.activeAccount.precision
                })
            },
            setActiveSymbol(symbol) {
                this.$store.commit(SYMBOL_ACTIVE_UPDATE, {
                    symbol,
                    id: this.chartActive
                })
            },
            showCloseOrderConfirmation(id) {
                if (!this.activeAccount.enable) {
                    this.$store.commit(NOTIFICATION_ERROR, 'TRADING_DISABLED')
                    return
                }

                this.$store.commit(MODAL_CLOSE_POSITION, {
                    activeOrderId: id
                })
                this.$store.commit(MODAL, {
                    closePosition: true
                })
            },
            showAutoCloseModal(e, id) {
                let rect = e.target.getBoundingClientRect()

                this.$store.commit(MODAL_AUTOCLOSE, {
                    left: rect.left,
                    top: rect.top,
                    symbolActive: null,
                    orderActive: id,
                    tp: this.activeAccount.orders[id].tp || '',
                    tpType: '=',
                    sl: this.activeAccount.orders[id].sl || '',
                    slType: '='
                })

                this.$store.commit(MODAL, {
                    autoClose: true
                })
            },
        }
    }
</script>

<style scoped>
    table {
        width: 100%;
        position: relative;
    }

    tr:hover {
        cursor: pointer;
    }

    tr:nth-child(even):not(.order-detail) td {
        background-color: rgba(255,255,255,0.02);
        border-top: 1px solid var(--border-table);
        border-bottom: 1px solid var(--border-table);
    }

    td, th {
        white-space: nowrap;
        text-align: right;
    }

    th {
        padding: 8px 0;
        position: sticky;
        top: 0;
        background-color: var(--background-dark);
    }

    td {
        text-align: right;
        color: var(--white-to-black);
        padding: 3px 0;
    }

    td:first-child, th:first-child {
        text-align: left;
        padding-left: 10px;
    }

    td:last-child, th:last-child {
        padding-right: 10px;
    }

    td:last-child span {
        cursor: pointer;
    }

    td:last-child span:first-child {
        margin-right: 15px;
    }

    td:first-child img {
        width: 14px;
        height: 14px;
        vertical-align: middle;
        margin-right: 5px;
    }

    td .symbol {
        zoom: 0.21875;
        margin-right: 23px;
        display: inline-block;
        vertical-align: middle;
        margin-bottom: 15px;
    }

    .compact-hide {
        display: none;
    }

    /* Rows can now grow a detail row underneath, which throws the even/odd stripe out of step.
       Separate compact rows with a rule instead. */
    tr.compact-row td {
        padding: 7px 0;
        border-top: 1px solid var(--border-table);
        border-bottom: none;
    }

    tr.compact-row:nth-child(even) td {
        background-color: transparent;
    }

    /* The actions cell is display:none when compact, so it still counts as :last-child and the
       P&L cell would sit flush against the edge. */
    .compact-table thead th:nth-last-child(2),
    tr.compact-row td:nth-last-child(2) {
        padding-right: 10px;
    }

    tr.order-detail td {
        background-color: rgba(255, 255, 255, 0.04);
        padding: 6px 10px 9px;
        text-align: left;
        white-space: normal;
    }

    .detail-grid {
        display: grid;
        grid-template-columns: auto 1fr auto 1fr;
        gap: 3px 8px;
        align-items: baseline;
    }

    .detail-grid .k {
        opacity: 0.7;
    }

    .detail-grid .v {
        color: var(--white-to-black);
        text-align: right;
    }

    .detail-actions {
        margin-top: 8px;
        text-align: right;
    }

    .detail-actions span {
        cursor: pointer;
        margin-left: 15px;
    }

    @-moz-document url-prefix() {
        td .symbol {
            -moz-transform: scale(0.21875);
            -moz-transform-origin: 50% 50%;
            position: absolute;
            left: -16px;
            top: -22px;
        }

        td:first-child {
            position: relative;
            padding-left: 28px !important;;
        }
    }
</style>
